var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emergency-button"},[_c('overlay-page-link',{attrs:{"type":'read-more',"label":_vm.data.label,"page":_vm.data.link}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }